// src/pages/SuccessPage.js

import React, { useEffect, useState } from 'react';
import { Container, Typography, Button, Box, CircularProgress, Snackbar, Alert, Stack } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { getTransactionBySessionId } from '../services/api'; // You need to implement this
import { useAuth } from '../context/AuthContext';

function SuccessPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { currentUser, loading: authLoading } = useAuth();
    const [transaction, setTransaction] = useState(null);
    const [loading, setLoading] = useState(true);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    // Extract session_id from query params
    const query = new URLSearchParams(location.search);
    const sessionId = query.get('session_id');

    useEffect(() => {
        const fetchTransaction = async () => {
            if (sessionId && currentUser && !authLoading) {
                try {
                    // Implement an API endpoint to get transaction by session ID
                    const response = await getTransactionBySessionId(sessionId);
                    setTransaction(response.data);
                } catch (err) {
                    console.error('Error fetching transaction:', err);
                    setSnackbar({ open: true, message: 'Error fetching transaction details.', severity: 'error' });
                } finally {
                    setLoading(false);
                }
            } else {
                setLoading(false);
            }
        };

        fetchTransaction();
    }, [sessionId, currentUser, authLoading]);

    const handleGoToTransactions = () => {
        navigate('/bookings'); // Adjust the path based on your routing
    };

    const handleViewThisTransaction = () => {
        if (transaction) {
            navigate(`/transactions/${transaction.id}`); // Navigate to the specific transaction details
        }
    };

    if (loading) {
        return (
            <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
                <CircularProgress />
                <Typography variant="h6" sx={{ mt: 2 }}>
                    Processing your payment...
                </Typography>
            </Container>
        );
    }

    return (
        <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center', mb: 8 }}>
            <Typography variant="h4" gutterBottom>
                Payment Successful!
            </Typography>
            <Typography variant="body1" gutterBottom>
                Thank you for your payment. Your transaction has been processed successfully.
            </Typography>
            {transaction && (
                <Box mt={2}>
                    <Typography variant="subtitle1">Transaction Details:</Typography>
                    <Typography variant="body2">Booking Number: {transaction.id}</Typography>
                    <Typography variant="body2">Amount: ${transaction.total_transaction_amount.toFixed(2)}</Typography>
                    <Typography variant="body2">Date: {new Date(transaction.updated_at).toLocaleString()}</Typography>
                </Box>
            )}

            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                justifyContent="center"
                sx={{ mt: 4 }}
            >
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleGoToTransactions}
                >
                    Go to My Bookings
                </Button>

                {transaction && (
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleViewThisTransaction}
                    >
                        View This Booking
                    </Button>
                )}
            </Stack>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
                <Alert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default SuccessPage;